<template>
    <div :class="{'box': campaign.type !== 'deal', 'mt-15': campaign.type === 'deal'}">
        <div class="deal-form-title mb-10" v-if="campaign.type !== 'deal'">
            Important Information
        </div>

        <tracking-notification :campaign="campaign" />

        <template v-if="campaign.show_revenue_tracking_information">
            <affiliate-link-notification :campaign="campaign" />
            <discount-code-notification :campaign="campaign" />
        </template>
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../../mixins/CampaignCustomizeMixin';
    import TrackingNotification from '../../campaign/partials/TrackingNotification.vue';
    import AffiliateLinkNotification from '../../campaign/partials/AffiliateLinkNotification.vue';
    import DiscountCodeNotification from '../../campaign/partials/DiscountCodeNotification.vue';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'JobTracking',

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [
            CampaignCustomizeMixin
        ],

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            TrackingNotification,
            DiscountCodeNotification,
            AffiliateLinkNotification
        },

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type:     Object,
                required: true
            }
        }
    }
</script>

